<template>
  <div class="m-bazaar shop-index shop-view">
      <div class="open-time"></div>
      <div class="shop-panel">
        <div class="shop-index-cap"></div>
        <div class="user-info">
          <m-user></m-user>
        </div>

        <div class="goods-list">
          <vuescroll>
            <ul>
                <li v-for="(item,index) in goodslist" :key="index">
                    <div class="goods-panel">
                        <div class="goods-detail">
                            <div class="goods-status">
                                <div class="tag tag-sale" v-if="item.discountType"></div>
                                <div class="tag tag-shop" v-if="item.shopOfferType"></div>
                            </div>
                            <h6 class="item-name">{{ item.name }} * {{ item.itemcount }}</h6>
                            <div class="discount">{{ item.discountName }}</div>
                            <div class="pic" 
                            v-if="$store.state.tipsimg.indexOf(item.itemid) > -1" 
                            @click="$item_tips({ item_id : item.itemid + '.png',type : 'img'})">
                            <!-- <img v-bind:src="item.img" v-bind:alt="item.name"> -->
                            <div class="item-pic"><game-item :id="item.itemid" :num="item.itemcount" :locked="true"></game-item></div>
                            </div>
                            <div class="pic" v-else 
                            @click="$item_tips({ item_id : item.itemid})"><div class="item-pic"><game-item :id="item.itemid" :num="item.itemcount" :locked="true"></game-item></div></div>
                            <div class="low">最低价<em class="icon-m3b"></em><span>{{ item.priceMin }}</span><span class="p-before">{{ item.priceBefore }}</span></div>
                            <div class="banner" v-bind:data-sid="item.shopId" @click="see_offer(item.shopId);">{{ item.shopName }}</div>
                        </div>
                    </div>

                    <div class="u-btn apply" @click="discountStart(item.id,index);"></div>
                </li>
            </ul>
          </vuescroll>

        </div>
      </div>
      <div class="bottom-bubble">
          <div class="txt-bubble"></div>
          <div class="u-btn u-top"></div>
      </div>       
  </div>
</template>

<script>
import userinfo from '@/components/userinfo.vue'
import vuescroll from 'vuescroll';

export default {
  name: 'bazaar',
  data () {
    return {
      goodslist : [],
      ops : {
        bar: {
            background: '#b28850',
            keepShow : true,
        }        
      }
    }
  },
  props : {
    shop_offer : {
      default : [],
    }
  },
  components : {
    'm-user': userinfo,
    vuescroll,
  },  
  created (){
    this.render();
  },
  methods : {
    render (){
      this.goodslist = this.$get_goodslist()
    },
    discountStart (gid,index){
      //TODO
      this.$share_modal({
        gid : gid,
      })

      this.goodslist.splice(index,1)
    },
    see_offer (sid){
      this.$router.push({ name: 'offer', params: { sid: sid }});
    } 
  },
}
</script>

<style scoped>

.shop-index {
    padding-top: 690px;
    background-image: url(~@/assets/images/body-ex.jpg);
    background-size: 100% auto;
    background-repeat: no-repeat;
    background-position: top center;
    box-sizing: border-box;
}

.shop-index .m-user {
    position: absolute;
    left: 0;
    top: -10px;
    width: 100%;
    padding: 0 40px;
    color: #d4a869;
    box-sizing: border-box;
    z-index: 6;
}

.shop-index .user-name{
    display: inline-block;
    width: 400px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;    
}

.open-time{
    position: absolute;
    right: 0;
    top: 0;
    width: 244px;
    height: 140px;
    background-image: url(~@/assets/images/act-time.png);
    z-index: 5;
}
</style>


// WEBPACK FOOTER //
// src/views/bazaar.vue